module.exports = __webpack_public_path__ + "static/media/HearingRoom.32b72b3e.png";